const PREFIX = 'EVENTS'

enum EventsConstants {
    EVENT_INITIALIZE,
    EVENT_INITIALIZE_SUCCESS,
    GET_EVENT_SETTINGS_SUCCESS,
    DELETE_EVENT_SETTINGS_SUCCESS,
    GET_EVENT,
    GET_EVENT_SUCCESS,
    GET_EVENT_ERROR,
    GET_EVENTS,
    GET_EVENTS_SUCCESS,
}

const SETTINGS = 'EVENTS_SETTINGS'

enum SettingConstants {
    SET_ORDER,
    SET_SPORT_FILTER,
    SET_SETTINGS,
}

export enum OrderConstants {
    NONE,
    DATE,
    MARKET,
    COMPARISON,
    BOOK
}

export const EVENT_INITIALIZE = PREFIX + '_' + EventsConstants.EVENT_INITIALIZE;
export const EVENT_INITIALIZE_SUCCESS = PREFIX + '_' + EventsConstants.EVENT_INITIALIZE_SUCCESS;

export const GET_EVENT_SETTINGS_SUCCESS = PREFIX + '_' + EventsConstants.GET_EVENT_SETTINGS_SUCCESS;
export const DELETE_EVENT_SETTINGS_SUCCESS = PREFIX + '_' + EventsConstants.DELETE_EVENT_SETTINGS_SUCCESS;

export const GET_EVENT = PREFIX + '_' + EventsConstants.GET_EVENT;
export const GET_EVENT_SUCCESS = PREFIX + '_' + EventsConstants.GET_EVENT_SUCCESS;
export const GET_EVENT_ERROR = PREFIX + '_' + EventsConstants.GET_EVENT_ERROR;
export const GET_EVENTS = PREFIX + '_' + EventsConstants.GET_EVENTS;
export const GET_EVENTS_SUCCESS = PREFIX + '_' + EventsConstants.GET_EVENTS_SUCCESS;

export const SET_ORDER = SETTINGS + '_' + SettingConstants.SET_ORDER;
export const SET_SETTINGS = SETTINGS + '_' + SettingConstants.SET_SETTINGS;
